import React from 'react';
import PropTypes from 'prop-types';

import { ResponsiveCheck } from 'core/providers/Responsive';

import RatingStars from 'core/components/RatingStars';
import LoginModalHoc from 'core/hoc/LoginModalHoc';
import { FavoriteButton, Share } from 'listing/components';

import {
	Wrapper,
	Name,
	Intro,
	Row,
	ShareAndLike,
	Store,
	StoreLink,
	AdminLink,
} from './titleStyles';

const Title = ({
	slug,
	name,
	intro,
	stars,
	reviews,
	noMeta,
	listingId,
	customerId,
	noLikes,
	onWishlistSuccess,
	triggerLogin,
	className,
	storeName,
	hasMoreProducts,
	isAdmin,
}) => (
	<ResponsiveCheck>
		{({ isDesktop }) => (
			<Wrapper className={className}>
				<Name>{name}</Name>
				{storeName && hasMoreProducts
					? <StoreLink to="more-products" smooth="easeInOutQuad" offset={-55}>by {storeName}</StoreLink>
					: <Store href={`/store/${slug}/`}>by {storeName}</Store>
				}
				<Intro dangerouslySetInnerHTML={{ __html: intro }} />

				{!noMeta && (
					<Row>
						<RatingStars slug={slug} stars={stars} reviews={reviews} />
						{!isDesktop &&
						<ShareAndLike>
							<Share url={`https://www.cratejoy.com/subscription-box/${slug}/`} />
							{!noLikes &&
							<FavoriteButton
								listingId={listingId}
								customerId={customerId}
								triggerLogin={triggerLogin}
							/>
							}
							{ isAdmin && <AdminLink href={`/subscription-box/${slug}/image_gallery/`} target={`blank`}>🖼️</AdminLink> }
						</ShareAndLike>
						}
						{ isDesktop && isAdmin && <AdminLink href={`/subscription-box/${slug}/image_gallery/`} target={`blank`}>🖼️</AdminLink> }
					</Row>
				)}
			</Wrapper>
		)}
	</ResponsiveCheck>
);


export const titleProps = {
	name: PropTypes.string.isRequired,
	intro: PropTypes.string.isRequired,
	slug: PropTypes.string.isRequired,
	stars: PropTypes.number,
	reviews: PropTypes.number,
	noLikes: PropTypes.bool,
	noMeta: PropTypes.bool,
	listingId: PropTypes.number,
	customerId: PropTypes.number,
	triggerLogin: PropTypes.func,
	onWishlistSuccess: PropTypes.func,
	className: PropTypes.string,
	storeName: PropTypes.string.isRequired,
	hasMoreProducts: PropTypes.bool,
	isAdmin: PropTypes.bool,
};

Title.propTypes = titleProps;

Title.defaultProps = {
	triggerLogin: () => null,
	onWishlistSuccess: () => null,
	isAdmin: false,
};

/* Wrap the Title to get access to LoginModalHoc */
const LoginCapableTitle = (props) =>
	<LoginModalHoc contextUsage="title-login">
		{({ triggerLoginModal }) =>
			<Title {...props} triggerLogin={triggerLoginModal} />
		}
	</LoginModalHoc>;


export default LoginCapableTitle;
